import { Platform, StyleSheet, ViewStyle } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const THUMBNAIL_WIDTH = 90;

const style = () => {
  const { colorBgBase, space2, space4, space8, space6, colorBgPrimaryMedium, colorText, colorTextMediumLight } =
    theme();

  return StyleSheet.create({
    activeIcon: {
      color: colorTextMediumLight,
    },
    box: {
      alignItems: "center",
      backgroundColor: colorBgBase,
      height: "100%",
    },
    button: {
      backgroundColor: colorBgBase,
    },
    content: {
      flex: 1,
      width: "100%",
    },
    fullHeight: {
      flex: 1,
    },
    header: {
      flexDirection: "row",
      marginVertical: space2,
      paddingHorizontal: space2,
    },
    icon: {
      color: colorText,
    },
    imagesThumbnails: {
      marginLeft: space8,
      marginRight: space4,
      marginTop: space6,
      width: THUMBNAIL_WIDTH,
      zIndex: 1,
    },
    layout: {
      height: "100%",
      justifyContent: "center",
    },
    mainImage: {
      marginHorizontal: "auto",
    },
    mainImageContent: {
      flex: 1,
      height: "100%",
      position: "absolute",
      top: 0,
      width: "100%",
    },
    mainImageTouchable: {
      width: "100%",
    },
    modal: {
      bottom: 0,
      flexDirection: "row",
      height: "100%",
      left: 0,
      overflow: "hidden",
      right: 0,
      top: 0,
      zIndex: 3,
    },
    navigation: {
      alignItems: "center",
      flexDirection: "row",
      gap: space2,
    },
    thumbnail: {
      borderColor: colorBgPrimaryMedium,
      borderWidth: 1,
      height: 112, // Design request
      marginBottom: space4,
      width: THUMBNAIL_WIDTH,
    },
    title: {
      justifyContent: "center",
    },
    wrapper: {
      flex: 1,
    },
    zoomIn: {
      ...Platform.select({
        web: {
          cursor: "zoom-in",
        },
      }),
    } as ViewStyle,
    zoomOut: {
      ...Platform.select({
        web: {
          cursor: "zoom-out",
        },
      }),
    } as ViewStyle,
  });
};

export { THUMBNAIL_WIDTH };
export { style };
